// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__n7qg4","image":"Header_image__1laF-","name":"Header_name__oAdfE","info":"Header_info__3CvMQ","infoRow":"Header_infoRow__3h0tB"};